var map = {
	"./LicensesFragment": "a2f9",
	"./LicensesFragment.vue": "a2f9",
	"./LocationsFragment": "1cb5",
	"./LocationsFragment.vue": "1cb5",
	"./PatientFragment": "a45b",
	"./PatientFragment.vue": "a45b",
	"./PracticeFragment": "402f",
	"./PracticeFragment.vue": "402f",
	"./ProfessionalInfoFragment": "129d",
	"./ProfessionalInfoFragment.vue": "129d",
	"./SpecialitiesFragment": "8a7a",
	"./SpecialitiesFragment.vue": "8a7a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "157b";